import DateSelector from "Dashboard/components/DateSelector";
import { useCallback, useEffect, useState } from "react";
import { selectState as mainSelectState } from "../slices/main.slice";
import { useSelector } from "react-redux";
import {
  getValuationsStatistics,
  selectState,
} from "../slices/ValuationsStatistics.slice";
import { useAppDispatch } from "hooks/hooks";
import Loader from "components/Loader/Loader";
import {
  FormatNumber,
  mapProjectCategories,
} from "../services/statistics.service";
import { FormatDate } from "utils/dateUtils";

export const CompanyStatistics = () => {
  const { statistics, loading } = useSelector(selectState);
  const { mainDateFrom } = useSelector(mainSelectState);
  const [dateFrom, setDateFrom] = useState<Date | null>(null);
  const [, setDateTo] = useState<Date | null>(null);
  const [projectsArray, setProjectsArray] = useState<number[]>([]);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (dateFrom != null) {
      dispatch(
        getValuationsStatistics({
          year: dateFrom.getFullYear(),
          projectIds: projectsArray,
        })
      );
    }
  }, [dateFrom, projectsArray]);

  const selectDate = useCallback((data: { dateFrom: Date; dateTo: Date }) => {
    setDateFrom(data.dateFrom);
    setDateTo(data.dateTo);
  }, []);

  const pushToArray = (index: number) => {
    let newProjectsArray: number[];
    if (projectsArray.includes(index)) {
      newProjectsArray = projectsArray.filter((element) => element !== index);
    } else {
      newProjectsArray = [...projectsArray, index];
    }
    setProjectsArray(newProjectsArray);
  };

  const getWidth = (num: number | undefined) => {
    let totalwidth = 0;
    if (statistics) {
      if (
        statistics.investmentsTotalAmount >= statistics.resourcesTotalValuation
      ) {
        totalwidth =
          statistics.investmentsTotalAmount +
          Math.abs(statistics.loansTotalAmount);
      } else {
        totalwidth =
          statistics.resourcesTotalValuation +
          Math.abs(statistics.loansTotalAmount);
      }
    }
    if (num) {
      let width = totalwidth / num;
      const result = Math.abs(100 / width);
      return Math.round(result);
    } else {
      return 0;
    }
  };

  return (
    <div className="mainDiv">
      <div className="header">Vrednost firme, Investicije i Pozajmice</div>
      <div className="graphs  loading-container">
        {loading && <Loader />}
        <div className="graphs-header carnets-header">
          <span>
            <div className="color13"></div>Investicije
          </span>
          <span>
            <div className="color14"></div>Pozajmice
          </span>
          <span>
            <div className="color15"></div>Vrednost resursa
          </span>
        </div>
        <div className="graphs-content">
          <div
            className={`companyGraphs-${getWidth(
              statistics?.loansTotalAmount
            )}`}
          >
            <span
              className={`${
                statistics?.loansTotalAmount && statistics?.loansTotalAmount < 0
                  ? "relative"
                  : ""
              }`}
            >
              <div
                className={`color13 companyGraph-${getWidth(
                  statistics?.investmentsTotalAmount
                )}`}
              ></div>
              <p className="amountBar">
                {FormatNumber(statistics?.investmentsTotalAmount)} rsd
              </p>
            </span>

            <span>
              {statistics?.loansTotalAmount !== undefined && 
                statistics?.loansTotalAmount < 0 && (
                  <p className="amountBar">
                    {FormatNumber(statistics?.loansTotalAmount)} rsd
                  </p>
                )}
              <div
                className={`color14 companyGraph-${getWidth(
                  statistics?.loansTotalAmount
                )}`}
              ></div>
              {statistics?.loansTotalAmount !== undefined &&
                statistics?.loansTotalAmount >= 0 && (
                  <p className="amountBar">
                    {FormatNumber(statistics?.loansTotalAmount)} rsd
                  </p>
                )}
            </span>
            <span
              className={`${
                statistics?.loansTotalAmount && statistics?.loansTotalAmount < 0
                  ? "relative"
                  : ""
              }`}
            >
              <div
                className={`color15 companyGraph-${getWidth(
                  statistics?.resourcesTotalValuation
                )}`}
              ></div>
              <p className="amountBar">
                {FormatNumber(statistics?.resourcesTotalValuation)} rsd
              </p>
            </span>
          </div>
        </div>
      </div>
      <table className="statistics-table-header">
        <colgroup>
          <col className="w5" />
          <col className="w24" />
          <col className="w11" />
          <col className="w10" />
          <col className="w10" />
          <col className="w10" />
          <col className="w11" />
          <col className="w11" />
        </colgroup>
        <thead>
          <tr>
            <th className="selector">
              <DateSelector
                selectedYear={mainDateFrom?.getFullYear()}
                showMonth={false}
                lastYearNumbers={5}
                selectDate={selectDate}
              />
            </th>
            <th className="header-cell">naziv projekta</th>
            <th className="header-cell">kategorija</th>
            <th>datum ugovora</th>
            <th>početak radova</th>
            <th className="header-cell">krajnji rok</th>
            <th className="header-cell">završio</th>
            <th>isplatili</th>
          </tr>
        </thead>
      </table>
      <table className="statistics-table-content loading-container">
        <colgroup>
          <col className="w5" />
          <col className="w24" />
          <col className="w11" />
          <col className="w10" />
          <col className="w10" />
          <col className="w10" />
          <col className="w11" />
          <col className="w11" />
        </colgroup>
        <tbody>
          {statistics?.entries &&
            statistics?.entries.map((project, index) => (
              <tr key={index}>
                <td className="firstBtn">
                  <div>
                    <input
                      onChange={() => pushToArray(project.projectId)}
                      type="checkbox"
                      checked={projectsArray.includes(project.projectId)}
                    />
                  </div>
                </td>
                <td>
                  <p>{project.projectName}</p>
                </td>
                <td>{mapProjectCategories(project.projectType.name)}</td>
                <td>{FormatDate(project.contractDate)}</td>
                <td>{FormatDate(project.startDate)}</td>
                <td>{FormatDate(project.finishDate)}</td>
                <td>{FormatDate(project.dueDate)}</td>
                <td>{FormatNumber(project.paidAmountTotal)} rsd</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};
